import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const login = (Email, Password) => {
  return api.post("/auth/login", { Email, Password });
};

export const createNewEmployee = (payload, isMultipart = false) => {
  console.log("Payload for creating a new employee:", isMultipart ? "FormData" : JSON.stringify(payload));

  const config = isMultipart
    ? {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    : {
        headers: {
          "Content-Type": "application/json",
        },
      };
  return api.post("/auth/signup", payload, config);
};

export const updateEmployee = (id, payload, isMultipart = false) => {
  console.log("Payload for updating an employee:", isMultipart ? "FormData" : JSON.stringify(payload));
  console.log("ID:", id);

  const config = isMultipart
    ? {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    : {
        headers: {
          "Content-Type": "application/json",
        },
      };

  // Wrap payload in userData object
  const wrappedPayload = { userData: payload };

  return api.patch(`/auth/users/${id}`, wrappedPayload, config);
};

export const getServiceCalls = () => {
  return api.get("/servicecalls");
};

export const getServiceCallByID = (id) => {
  return api.get(`/servicecalls/${id}`);
};
export const updateServiceCall = (id, payload, isMultipart = false) => {
  console.log(
    "Payload in updateServiceCall API:",
    isMultipart ? "FormData" : JSON.stringify(payload)
  );

  const config = isMultipart
    ? {} // Axios automatically handles multipart form boundary.
    : {
        headers: {
          "Content-Type": "application/json",
        },
      };

  return api.put(`/servicecalls/${id}`, payload, config);
};

export const NewServiceCall = (payload, isMultipart = false) => {
  console.log(
    "Formatted data in API:",
    isMultipart ? "FormData" : JSON.stringify(payload)
  );

  const config = isMultipart
    ? {} // Axios automatically sets multipart boundaries
    : {
        headers: {
          "Content-Type": "application/json",
        },
      };

  return api.post("/servicecalls/", payload, config);
};

export const fetchProjectDetails = () => {
  return api.get("/projects");
};

export const fetchProjectById = (id) => {
  return api.get(`/projects/${id}`);
};

export const updateProjectById = (id, payload, isMultipart = false) => {
  console.log(
    "Payload in updateServiceCall API:",
    isMultipart ? "FormData" : JSON.stringify(payload)
  );

  const config = isMultipart
    ? {} // Axios automatically handles multipart form boundary.
    : {
        headers: {
          "Content-Type": "application/json", 
        },
      };

  return api.put(`/projects/${id}`, payload, config);
};

export const createProjects = (formattedData) => {
  console.log("Formatted data in API:", JSON.stringify(formattedData, null, 2));
  return api.post("/projects/create", formattedData);
};

export const createNewProjects = (payload, isMultipart = false) => {
  console.log(
    "Formatted data in API:",
    isMultipart ? "FormData" : JSON.stringify(payload)
  );

  const config = isMultipart
    ? {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    : {
        headers: {
          "Content-Type": "application/json",
        },
      };

  return api.post("/projects/create/", payload, config);
};

export const fetchUserData = () => {
  return api.get("/auth/users/"); 
};

export const fetchTaskSubTask = () => {
  return api.get("/taskcategories/get");
};

export const fetchTimesheetsProject = () => {
  return api.get("/timesheet"); 
};

export const fetchTimesheetsEmployeeName = () => {
  return api.get("/timesheet/filterNames"); 
};

export const getTimesheetData = async () => {
  try {
    const response = await api.get("/timesheet");
    return response.data;
  } catch (error) {
    console.error("Error fetching timesheet data:", error);
    throw error;
  }
};

export default api;
